import {SubscriptionPlanInfoResponse} from "../interface/subscriptionPlanInfoResponse";

export class SubscriptionPlanInfoModel {

  subscriptionPlanData: SubscriptionPlanInfoResponse | any;
  isIndividuals: boolean;
  isStarter: boolean;
  isStandard: boolean;
  isYearly: boolean;

  constructor(
    subscriptionPlanData: SubscriptionPlanInfoResponse | any,
    isIndividuals: boolean = true,
    isStarter: boolean = false,
    isStandard: boolean = false,
    issYearly: boolean = false
  ) {
    this.subscriptionPlanData = subscriptionPlanData;
    this.isIndividuals = isIndividuals;
    this.isStarter = isStarter;
    this.isStandard = isStandard;
    this.isYearly = issYearly;
  }
}
